/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';

import UnitEnum from 'astro/enum/unit';
import ShapeEnum from 'shared/enum/shape';
import SelectTypeEnum from 'shared/enum/select.type';


const isRangeTargetEntity = (type) =>
{
  return type === UnitEnum.Artillery || type === UnitEnum.AssaultTroops || type === UnitEnum.MechInfantry || type === UnitEnum.SpecialForces || type === UnitEnum.Gate;
}


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return isRangeTargetEntity(this.args.type);
  }


  getSelectType ()
  {
    if (this.args.type === UnitEnum.Gate)
    {
      return SelectTypeEnum.Galaxy;
    }

    return SelectTypeEnum.Zone;
  }


  getSelectShape (source, galaxy)
  {
    switch (this.args.type)
    {
      case UnitEnum.Artillery:     return ShapeEnum.QuadrupleArea;
      case UnitEnum.MechInfantry:  return ShapeEnum.TripleArea;
      case UnitEnum.AssaultTroops: return ShapeEnum.Single;
      case UnitEnum.SpecialForces: return ShapeEnum.Single;
      case UnitEnum.Gate:          return ShapeEnum.Single;
    }

    return super.getSelectShape(source, galaxy);
  }


  isPaneCollapsed ()
  {
    return false;
  }


};

